import { render, staticRenderFns } from "./dedicatedDietRecommedCategories.vue?vue&type=template&id=1a5089fd"
import script from "./dedicatedDietRecommedCategories.vue?vue&type=script&lang=js"
export * from "./dedicatedDietRecommedCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports